const selectStyles = (field) => {
    return {
        control: (provided, state) => {
            let outline = provided.outline;
            let boxShadow = provided.boxShadow;
            let borderColor = provided.borderColor;
            let backgroundColor = provided.backgroundColor;

            if (!state.isDisabled) {
                if (state.menuIsOpen || state.isFocused) {
                    outline = 0;
                    borderColor = `#80bdff`;
                    boxShadow = `0 0 0 .2rem rgba(0,123,255,.25)`;
                }

                if (field.validate) {
                    if (field.touched && !field.valid) {
                        borderColor = `#dc3545`;
                        if (state.menuIsOpen || state.isFocused) {
                            boxShadow = `0 0 0 .2rem rgba(220,53,69,.25)`
                        }
                    }

                    if (field.touched && field.valid) {
                        borderColor = `#28a745`;
                        if (state.menuIsOpen || state.isFocused) {
                            boxShadow = `0 0 0 .2rem rgba(40,167,69,.25)`
                        }
                    }
                }
            } else {
                backgroundColor = `#e9ecef`;
                borderColor = `#ced4da`;
            }

            const newStyles = {
                ...outline,
                boxShadow,
                borderColor,
                backgroundColor,
                transition: `none`,
                borderRadius: `20px`,
                ...(
                    state.menuIsOpen ? {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    } : {})
            }
            return {
                ...provided,
                ...newStyles,
                ':hover': {
                    ...provided[':hover'],
                    ...newStyles
                },
            }
        },
        placeholder: (provided, state) => {
            const newStyles = {
                color: '#6c757d'
            }

            return {
                ...provided,
                ...newStyles
            }
        },
        indicatorSeparator: (provider, state) => {
            return {
                display: 'none'
            }
        },
        menu: (provided, state) => {
            const newStyles = {
                borderRadius: '14px',
                border: `1px solid lightgray`,
                marginTop: '-1px',
                width: 'calc(100% - 2px)',
                marginLeft: '1px',
                overflow: 'hidden',
                zIndex: 9999,
                boxShadow: '0 .09rem .25rem rgba(128,128,128,.25)',
                borderTopLeftRadius: '0.05rem',
                borderTopRightRadius: '0.05rem',
            }
            return {
                ...provided,
                ...newStyles
            }
        },
        menuPortal: (provided, state) => {
            return {
                ...provided,
                zIndex: 9999
            }
        },
        menuList: (provided, state) => {
            const newStyles = {
                padding: 0
            }
            return {
                ...provided,
                ...newStyles
            }
        },
        option: (provided, state) => {
            return {
                ...provided,
                backgroundColor: state.isFocused ? 'var(--primary)' : 'var(--light)',
                color: state.isFocused ? '#fff' : 'inherit',
                padding: '0.45rem 1.25rem',
                ':hover': {
                    ...provided.hover,
                    backgroundColor: 'var(--primary)',
                    color: '#fff'
                }
            }
        },
        multiValue: (provided, state) => {
            return {
                ...provided,
                borderRadius: '3em',
                overflow: 'hidden',
                marginRight: '0.85rem',
                marginLeft: '-0.7rem',
                backgroundColor: 'var(--dark)'
            }
        },
        multiValueLabel: (provided, state) => {
            return {
                ...provided,
                paddingLeft: '0.7rem',
                paddingTop: '0.25rem',
                fontWeight: 400,
                color: '#fff',
                backgroundColor: 'var(--dark)'
            }
        },
        multiValueRemove: (provided, state) => {
            return {
                ...provided,
                borderRadius: 0,
                paddingRight: '0.5rem',
                paddingTop: '0.1rem',
                backgroundColor: 'var(--dark)',
                'svg': {
                    fill: 'white'
                },
                ':hover': {
                    ...provided[':hover'],
                    backgroundColor: 'rgba(255,255,255,0.150)'
                }
            }
        },
        valueContainer: (provided, state) => {
            return {
                ...provided,
                paddingLeft: '1rem',
                fontWeight: 400
            }
        }
    }
}

export default selectStyles;
